/*
 * Globalize Culture el-GR
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("el-GR", "default", {
    name: "el-GR",
    englishName: "Greek (Greece)",
    nativeName: "Ελληνικά (Ελλάδα)",
    language: "el",
    numberFormat: {
      ",": ".",
      ".": ",",
      NaN: "μη αριθμός",
      negativeInfinity: "-Άπειρο",
      positiveInfinity: "Άπειρο",
      percent: {
        pattern: ["-n%", "n%"],
        ",": ".",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": ".",
        ".": ",",
        symbol: "€"
      }
    },
    calendars: {
      standard: {
        firstDay: 1,
        days: {
          names: [
            "Κυριακή",
            "Δευτέρα",
            "Τρίτη",
            "Τετάρτη",
            "Πέμπτη",
            "Παρασκευή",
            "Σάββατο"
          ],
          namesAbbr: ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"],
          namesShort: ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σά"]
        },
        months: {
          names: [
            "Ιανουάριος",
            "Φεβρουάριος",
            "Μάρτιος",
            "Απρίλιος",
            "Μάιος",
            "Ιούνιος",
            "Ιούλιος",
            "Αύγουστος",
            "Σεπτέμβριος",
            "Οκτώβριος",
            "Νοέμβριος",
            "Δεκέμβριος",
            ""
          ],
          namesAbbr: [
            "Ιαν",
            "Φεβ",
            "Μαρ",
            "Απρ",
            "Μαϊ",
            "Ιουν",
            "Ιουλ",
            "Αυγ",
            "Σεπ",
            "Οκτ",
            "Νοε",
            "Δεκ",
            ""
          ]
        },
        monthsGenitive: {
          names: [
            "Ιανουαρίου",
            "Φεβρουαρίου",
            "Μαρτίου",
            "Απριλίου",
            "Μαΐου",
            "Ιουνίου",
            "Ιουλίου",
            "Αυγούστου",
            "Σεπτεμβρίου",
            "Οκτωβρίου",
            "Νοεμβρίου",
            "Δεκεμβρίου",
            ""
          ],
          namesAbbr: [
            "Ιαν",
            "Φεβ",
            "Μαρ",
            "Απρ",
            "Μαϊ",
            "Ιουν",
            "Ιουλ",
            "Αυγ",
            "Σεπ",
            "Οκτ",
            "Νοε",
            "Δεκ",
            ""
          ]
        },
        AM: ["πμ", "πμ", "ΠΜ"],
        PM: ["μμ", "μμ", "ΜΜ"],
        eras: [{ name: "μ.Χ.", start: null, offset: 0 }],
        patterns: {
          d: "d/M/yyyy",
          D: "dddd, d MMMM yyyy",
          f: "dddd, d MMMM yyyy h:mm tt",
          F: "dddd, d MMMM yyyy h:mm:ss tt",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Πρόσθετη βοήθεια",
      AddNewTab: "Προσθήκη νέας καρτέλας",
      Alerts: "Ειδοποιήσεις",
      ApplyFilter: "Εφαρμογή φίλτρου",
      Approve: "Έγκριση",
      Attachments: "Συνημμένα",
      Back: "Επιστροφή",
      Basic: "Βασική",
      Between: "Μεταξύ",
      Book: "Βιβλίο",
      Cancel: "Άκυρο",
      Checked: "Ελέγχθηκε",
      ClearFilter: "Απαλοιφή φίλτρου",
      Close: "Κλείσιμο",
      CloseCancelChanges: "Κλείσιμο και ακύρωση αλλαγών",
      CloseSaveChanges: "Κλείσιμο και αποθήκευση αλλαγών",
      CloseTab: "Κλείσιμο καρτέλας",
      ColumnPersonalization: "Εξατομίκευση στήλης",
      Comments: "Σχόλια",
      Confirmation: "Επιβεβαίωση",
      Contains: "Περιέχει",
      CreateTab: "Δημιουργία νέας καρτέλας",
      Cut: "Αποκοπή",
      Delete: "Διαγραφή",
      DiscardUndo: "Απόρριψη/Αναίρεση",
      DisplayDropDownList: "Εμφάνιση αναπτυσσόμενης λίστας",
      Displaying: "Εμφάνιση: ",
      DocWord: "Έγγραφο",
      DoesNotContain: "Δεν περιέχει",
      DoesNotEndWith: "Δεν τελειώνει με",
      DoesNotEqual: "Δεν ισούται με",
      DoesNotStartWith: "Δεν αρχίζει με",
      Download: "Λήψη",
      Duplicate: "Διπλότυπο",
      Edit: "Επεξεργασία",
      EitherSelectedorNotSelected: "Είτε επιλεγμένο είτε Μη επιλεγμένο",
      Email: "Email",
      EndsWith: "Τελειώνει με",
      EqualsStr: "Ισούται με",
      ExpandCollapse: "Ανάπτυξη/Σύμπτυξη",
      ExportFailed: "Η εξαγωγή απέτυχε",
      ExportToExcel: "Εξαγωγή στο Excel",
      FileInUse: "Το αρχείο που καθορίστηκε χρησιμοποιείται",
      FileInUseDetail:
        "Κλείστε το αρχείο στην εφαρμογή όπου χρησιμοποιείται ή καθορίστε διαφορετικό όνομα αρχείου.",
      Filter: "Φίλτρο",
      FilterMenu: "Μενού φίλτρου",
      FilterOptions: "Επιλογές φίλτρου",
      FilterWithinResults: "Φίλτρο εντός των αποτελεσμάτων",
      First: "Πρώτη",
      FirstView: "Πρώτη προβολή",
      Folder: "Φάκελος",
      ForgotPassword: "Ξεχάσατε τον κωδικό σας;",
      Forward: "Εμπρός",
      GetMoreRows: "Λήψη περισσότερων γραμμών",
      GreaterThan: "Μεγαλύτερο από",
      GreaterThanOrEquals: "Μεγαλύτερο από ή ίσο με",
      GridSettings: "Ρυθμίσεις πλέγματος",
      GroupSelection: "Επιλογή ομάδας",
      Help: "Βοήθεια",
      HideColumn: "Απόκρυψη στήλης",
      IsEmpty: "Είναι κενό",
      IsNotEmpty: "Δεν είναι κενό",
      Last: "Τελευταία",
      LastView: "Τελευταία προβολή",
      LaunchActivate: "Εκκίνηση/Ενεργοποίηση",
      LessThan: "Μικρότερο από",
      LessThanOrEquals: "Μικρότερο από ή ίσο με",
      Links: "Συνδέσεις",
      ListTabs: "Παράθεση όλων των καρτελών",
      LoadingItem: "Φόρτωση στοιχείου ",
      Maintenance: "Συντήρηση",
      Menu: "Μενού",
      New: "Νέο",
      Next: "Επόμενο",
      NextView: "Επόμενη προβολή",
      No: "Όχι",
      NotChecked: "Δεν ελέγχθηκε",
      Notes: "Σημειώσεις",
      NotSelected: "Μη επιλεγμένο",
      Of: " από ",
      Ok: "OK",
      Open: "Άνοιγμα",
      Password: "Κωδικός πρόσβασης",
      Paste: "Επικόλληση",
      Phone: "Τηλέφωνο",
      PleaseWait: "Περιμένετε",
      Previous: "Προηγούμενο",
      PreviousView: "Προηγούμενη προβολή",
      Print: "Εκτύπωση",
      Queries: "Ερωτήματα",
      Redo: "Επανάληψη",
      Refresh: "Ανανέωση",
      Reject: "Απόρριψη",
      RememberMe: "Απομνημόνευση των στοιχείων μου σε αυτόν τον υπολογιστή",
      Reports: "Αναφορές",
      Reset: "Επαναφορά",
      Review: "Αναθεώρηση",
      RunFilter: "Εκτέλεση φίλτρου",
      RunJob: "Εκτέλεση εργασίας",
      Save: "Αποθήκευση",
      SaveBeforeClosing: "Αποθήκευση πριν από το κλείσιμο",
      SavedFilters: "Αποθηκευμένα φίλτρα",
      SaveSubmit: "Αποθήκευση/Υποβολή",
      ScreenDesign: "Σχεδίαση οθόνης",
      Search: "Αναζήτηση",
      SelectContents: "Επιλογή περιεχομένων",
      SelectDate: "Επιλέξτε ημερομηνία",
      SelectDeselect: "Επιλογή / Κατάργηση επιλογής όλων",
      Selected: "Επιλεγμένο: ",
      ServerName: "Όνομα διακομιστή",
      Settings: "Ρυθμίσεις",
      ShowFilterRow: "Εμφάνιση σειράς φίλτρου",
      SignIn: "Είσοδος",
      SortAscending: "Αύξουσα ταξινόμηση",
      SortDescending: "Φθίνουσα ταξινόμηση",
      Spreadsheet: "Υπολογιστικό φύλλο",
      StartsWith: "Αρχίζει με",
      StatusIndicator: "Δείκτης κατάστασης",
      Tasks: "Εργασίες",
      Today: "Σήμερα",
      Translate: "Μετάφραση",
      UserID: "Αναγνωριστικό χρήστη",
      Utilities: "Βοηθητικά προγράμματα",
      Yes: "Ναι",
      Page: "Σελίδα",
      Rows: "Γραμμές",
      ShowingAll: "Εμφάνιση όλων",
      SessionNavigation: "Περιήγηση περιόδων λειτουργίας",
      ListAllMenuItems: "Παράθεση όλων των στοιχείων μενού",
      NoRecordsFound: "Δεν βρέθηκαν εγγραφές",
      SearchTree: "Δέντρο αναζήτησης",
      Clear: "Απαλοιφή",
      DrillDown: "Διερεύνηση",
      Required: "Αυτό το πεδίο είναι υποχρεωτικό",
      Available: "Διαθέσιμο:",
      Add: "Προσθήκη",
      MoveDown: "Μετακίνηση προς τα κάτω",
      MoveUp: "Μετακίνηση προς τα πάνω",
      Remove: "Κατάργηση",
      LastYear: "Προηγούμενο έτος",
      NextMonth: "Επόμενος μήνας",
      NextWeek: "Επόμενη εβδομάδα",
      NextYear: "Επόμενο έτος",
      OneMonthAgo: "Πριν από ένα μήνα",
      OneWeekAgo: "Πριν από μία εβδομάδα",
      SixMonthsAgo: "Πριν από έξι μήνες",
      Time: "Ώρα",
      CannotBeSelected: "Δεν είναι δυνατή η επιλογή αυτής της γραμμής:",
      ResetToDefault: "Επαναφορά στην προεπιλεγμένη διάταξη",
      CloseOtherTabs: "Κλείσιμο υπόλοιπων ετικετών",
      EmailValidation: "Καταχωρίστε έγκυρη διεύθυνση e-mail",
      UrlValidation: "Καταχωρίστε έγκυρη URL",
      EndofResults: "Τέλος των αποτελεσμάτων",
      More: "Περισσότερα...",
      RecordsPerPage: "Εγγραφές ανά σελίδα",
      Maximize: "Μεγιστοποίηση",
      Minimize: "Ελαχιστοποίηση",
      CloseAllTabs: "Κλείσιμο όλων των ετικετών",
      QuickDates: "Γρήγορες ημερομηνίες",
      Finish: "Τέλος",
      SetTextColor: "Ορισμός χρώματος κειμένου",
      AttachmentRules: "Κανόνες συνημμένων",
      AutoRefresh: "Αυτόματη ανανέωση",
      BarChart: "Γράφημα ράβδων",
      CopyMail: "Αντιγραφή και αποστολή με ταχυδρομείο",
      CopyUrl: "Αντιγραφή Url",
      DistributeHorizontally: "Διανομή οριζοντίως",
      ExpandAll: "Ανάπτυξη όλων",
      Generate: "Δημιουργία",
      GenerateScript: "Δημιουργία δέσμης ενεργειών",
      NoAttachments: "Κανένα συνημμένο",
      PieChart: "Γράφημα πίτας",
      QuickAccess: "Γρήγορη πρόσβαση",
      RestoreUser: "Επαναφορά χρήστη",
      SaveConsolidate: "Αποθήκευση με τοπική ενοποίηση",
      "Screen Design": "Σχεδίαση οθόνης",
      SelectAll: "Επιλογή όλων",
      SpellCheck: "Ορθογραφικός έλεγχος",
      SubmitForApproval: "Υποβολή για έγκριση",
      Timezone: "Ζώνη ώρας",
      Loading: "Φόρτωση…",
      NewNode: "Νέος κόμβος",
      RememberSettings: "Απομνημόνευση αυτών των ρυθμίσεων",
      Company: "Εταιρεία",
      Environment: "Περιβάλλον",
      DontHaveAccount: "Δεν έχετε λογαριασμό;",
      ResetPassword: "Επαναφορά του κωδικού πρόσβασής μου",
      SignUpNow: "Εγγραφή τώρα",
      SelectMonthYear: "Επιλέξτε μήνα και έτος"
    }
  });
})(this);
